import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FOR_INVESTORS_SECTIONS } from 'constants/businessToolSections/forInvestors';

import { FieldArrayComponent } from 'components/_basic/Form/FieldArray';
import { TextInputControl } from 'components/_basic/Form/TextInput';
import { FormHeader } from 'components/_basic/FormHeader/FormHeader';
import { FormSectionCard } from 'components/_basic/FormSectionCard/FormSectionCard';
import { FORM_SECTION_CARD_VARIANT } from 'components/_basic/FormSectionCard/types';
import {
  ABOUT_COMPANY_MISSION_NAMES,
  goalAndObjectiveRowInitialValues,
  prefix as missionPrefix,
} from 'components/BusinessToolForm/Sections/AboutCompany/MissionAndVision/utils/form';
import { GoalAndObjectiveRow } from 'components/BusinessToolForm/Sections/ExecutiveSummary/GoalsExecSummary/components/GoalAndObjectiveRow';
import { GLOBAL_FIELD_NAMES, globalPrefix } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

export const AboutTheProject: React.FC = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const canAccess = true;

  return (
    <>
      <FormSectionCard variant={FORM_SECTION_CARD_VARIANT.LARGE}>
        <FormHeader
          title={t(`chapters.${FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT}`)}
          badgeText={t('chapters.ABOUT_THE_PROJECT')}
          locked={!canAccess}
          section={FOR_INVESTORS_SECTIONS.COMPANY_AND_PROJECT}
        />
      </FormSectionCard>
      <FormSectionCard
        title={t('overview.project.briefProjectDescription')}
        aiFieldName={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION)}
        aiOnlyUpdate
        disabled={!canAccess}
      >
        <TextInputControl
          multiline
          control={control}
          id="overview.company.briefProjectDescription"
          name={concatWithDot(globalPrefix, GLOBAL_FIELD_NAMES.PROJECT_BRIEF_DESCRIPTION)}
          disabled={!canAccess}
          minRows={3}
          maxLength={1500}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('executiveSummary.goalsAndObjectives.mainGoals')}
        aiFieldName={concatWithDot(missionPrefix, ABOUT_COMPANY_MISSION_NAMES.GOALS)}
        aiFieldType="complex"
        collapsible
      >
        <FieldArrayComponent
          name={concatWithDot(missionPrefix, ABOUT_COMPANY_MISSION_NAMES.GOALS)}
          initialItem={goalAndObjectiveRowInitialValues}
          buttonText={t('goal')}
          disabled={!canAccess}
        >
          {(namePrefix) => <GoalAndObjectiveRow name={namePrefix} disabled={!canAccess} />}
        </FieldArrayComponent>
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('company.mission.problemOfMarket')}
        aiFieldName={concatWithDot(missionPrefix, ABOUT_COMPANY_MISSION_NAMES.PROBLEM_OF_MARKET)}
      >
        <TextInputControl
          multiline
          control={control}
          id="company.mission.problemOfMarket"
          name={concatWithDot(missionPrefix, ABOUT_COMPANY_MISSION_NAMES.PROBLEM_OF_MARKET)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
      <FormSectionCard
        disabled={!canAccess}
        title={t('company.mission.howProjectAddressesTheProblem')}
        aiFieldName={concatWithDot(missionPrefix, ABOUT_COMPANY_MISSION_NAMES.HOW_PROJECT_ADDRESSES_THE_PROBLEM)}
      >
        <TextInputControl
          multiline
          control={control}
          id="company.mission.howProjectAddressesTheProblem"
          name={concatWithDot(missionPrefix, ABOUT_COMPANY_MISSION_NAMES.HOW_PROJECT_ADDRESSES_THE_PROBLEM)}
          minRows={3}
          disabled={!canAccess}
          maxLength={1500}
        />
      </FormSectionCard>
    </>
  );
};
